/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * FOCUS_LOST and FOCUS_BACK — the window lost focus and got it back; TAB_HIDDEN and TAB_VISIBLE — the tab was hidden and shown again; FULLSCREEN_LEFT; PRINT_SCREEN; COPY; PASTE; CONTEXT_MENU; QUESTION_OPENED — a question came on the screen.
 * @export
 * @enum {string}
 */

export const AttemptEventTypeDto = {
    FocusLost: 'FOCUS_LOST',
    FocusBack: 'FOCUS_BACK',
    TabHidden: 'TAB_HIDDEN',
    TabVisible: 'TAB_VISIBLE',
    FullscreenLeft: 'FULLSCREEN_LEFT',
    PrintScreen: 'PRINT_SCREEN',
    Copy: 'COPY',
    Paste: 'PASTE',
    ContextMenu: 'CONTEXT_MENU',
    QuestionOpened: 'QUESTION_OPENED'
} as const;

export type AttemptEventTypeDto = typeof AttemptEventTypeDto[keyof typeof AttemptEventTypeDto];



